(() => {
  // Section assets may be evaluated again by Shopify's editor. Delegate once so
  // newly rendered cards work without accumulating per-card listeners or timers.
  if (window.reaperEventCardTiltInitialized) return;
  window.reaperEventCardTiltInitialized = true;
  const motion = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  let active = null;
  let bounds = null;
  let pendingFrame = 0;
  let pointerX = 0;
  let pointerY = 0;

  function reset() {
    if (pendingFrame) cancelAnimationFrame(pendingFrame);
    pendingFrame = 0;
    if (active) {
      active.removeAttribute('data-tilt-active');
      active.style.removeProperty('--card-tilt-x');
      active.style.removeProperty('--card-tilt-y');
    }
    active = null;
    bounds = null;
  }

  function update() {
    pendingFrame = 0;
    if (!active || !active.isConnected || !motion.matches) {
      reset();
      return;
    }
    // Read the stationary wrapper, never the rotated card: transformed bounds
    // would feed back into the next angle and cause wobble near the edges.
    const x = Math.max(-1, Math.min(1, ((pointerX - bounds.left) / bounds.width - 0.5) * 2));
    const y = Math.max(-1, Math.min(1, ((pointerY - bounds.top) / bounds.height - 0.5) * 2));
    active.style.setProperty('--card-tilt-x', `${(-y * 6).toFixed(2)}deg`);
    active.style.setProperty('--card-tilt-y', `${(x * 6).toFixed(2)}deg`);
    // A broad diagonal reflection sweeps with the card's tilt, rather than
    // placing a circular light at the pointer. Retain it in place while fading.
    active.style.setProperty('--card-sheen-position', `${(50 + x * 30).toFixed(2)}%`);
    active.style.setProperty('--card-sheen-angle', `${(115 + y * 8).toFixed(2)}deg`);
  }

  function track(event) {
    if (!motion.matches || event.pointerType !== 'mouse') return;
    const card = event.target.closest('[data-card-tilt]');
    if (!card) return;
    if (card !== active) {
      reset();
      bounds = card.getBoundingClientRect();
      if (!bounds.width || !bounds.height) { bounds = null; return; }
      active = card;
      active.setAttribute('data-tilt-active', '');
    }
    pointerX = event.clientX;
    pointerY = event.clientY;
    // Coalesce rapid mouse events; no animation loop runs while the mouse rests.
    if (!pendingFrame) pendingFrame = requestAnimationFrame(update);
  }

  document.addEventListener('pointerover', track, { passive: true });
  document.addEventListener('pointermove', track, { passive: true });
  document.addEventListener('pointerout', (event) => {
    if (active && !active.contains(event.relatedTarget)) reset();
  }, { passive: true });
  document.addEventListener('pointercancel', reset, { passive: true });
  window.addEventListener('blur', reset);
  window.addEventListener('resize', reset, { passive: true });
  // Scroll invalidates the cached rectangle, including scrolling inside a panel.
  document.addEventListener('scroll', reset, { passive: true, capture: true });
  document.addEventListener('visibilitychange', reset);
  motion.addEventListener('change', reset);
  document.addEventListener('shopify:section:unload', (event) => {
    if (active && event.target.contains(active)) reset();
  });
})();
